import {
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Switch,
} from "@chakra-ui/react";
import translations from "../content/content";

function ToggleLanguage({ language, setLanguage }) {
  return (
    <FormControl>
      <Grid>
        <GridItem colStart={3} colEnd={11}>
          <FormLabel htmlFor="langSwitch">
            {translations[language].switchLabel}
          </FormLabel>
        </GridItem>
        <GridItem colStart={11}>
          <Switch
            id="langSwitch"
            onChange={() =>
              setLanguage(language === "english" ? "afrikaans" : "english")
            }
          ></Switch>
        </GridItem>
      </Grid>
    </FormControl>
  );
}

export default ToggleLanguage;
